export default function Error() {
  return (
    <div id="error-page" className="flex h-[85vh] items-center justify-center">
      <h1>Sorry, the page you are looking for could not be found.</h1>
    </div>
  );
}
